import './ProgressBar.css';
import React from "react";

function ProgressBar(props) {
    // const pxp = props.date.pxp
    // const gxp = props.date.gxp
    const pxp = 0
    const gxp = 0
    return (
        <div className="progressBar">
            <div className="boxLine"></div>
            <div className="progessBarEdge">
                <div className="innerProgressCircle glowCircle"></div>
            </div>
            <div className="longBox">
                <div style={{ marginTop: '0.5vw', marginRight: '0.75vw', marginLeft: '0.75vw', height: pxp / 150 * 13 + 'vw', width: '2vw', backgroundColor: '#292b72' }}></div>
            </div>
            <div className="progessBarEdge">
                {pxp > 149 && gxp > 149 &&
                    <div className="innerProgressCircle completedCircle"></div>
                }
            </div>
            <div className="longBox">
                <div style={{ marginTop: '0.5vw', marginRight: '0.75vw', marginLeft: '0.75vw', height: gxp / 150 * 13 + 'vw', width: '2vw', backgroundColor: '#0294db' }}></div>
            </div>
            <div className="progessBarEdge">
                <div className="innerProgressCircle powerCircle"></div>
            </div>
        </div>
    )
}

export default ProgressBar;